import { render, staticRenderFns } from "./GalleryOutro.vue?vue&type=template&id=0ce1190b&scoped=true&"
import script from "./GalleryOutro.vue?vue&type=script&lang=ts&"
export * from "./GalleryOutro.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryOutro.vue?vue&type=style&index=0&id=0ce1190b&lang=stylus&scoped=true&"
import style1 from "./GalleryOutro.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce1190b",
  null
  
)

export default component.exports